import { z } from 'zod';
import { optionalUuidString, requiredUuidString } from '../zod-helpers/index.js';
import { SALES_ORDER_HEADER_CONSTRAINTS } from './header-constraints.js';
// Mirrors the header portion of salesOrderCreateFormSchema -- lines/samplePurpose are staged
// client-side and sent via separate mutations after this one creates the order header.
export const createSalesOrderInputSchema = z.object({
    customerId: requiredUuidString(`${SALES_ORDER_HEADER_CONSTRAINTS.customer.label} is required.`, 'Invalid customer selection.'),
    brandId: requiredUuidString(`${SALES_ORDER_HEADER_CONSTRAINTS.brand.label} is required.`, 'Invalid brand selection.'),
    locationGroupId: requiredUuidString(`${SALES_ORDER_HEADER_CONSTRAINTS.locationGroup.label} is required.`, 'Invalid warehouse selection.'),
    paymentTermsId: requiredUuidString(`${SALES_ORDER_HEADER_CONSTRAINTS.paymentTerms.label} is required.`, 'Invalid payment terms selection.'),
    note: z
        .string()
        .max(SALES_ORDER_HEADER_CONSTRAINTS.note.max, `${SALES_ORDER_HEADER_CONSTRAINTS.note.label} must be ${SALES_ORDER_HEADER_CONSTRAINTS.note.max.toLocaleString('en-US')} characters or less.`)
        .optional()
        .nullable(),
    deliveryPreferences: z
        .string()
        .max(SALES_ORDER_HEADER_CONSTRAINTS.deliveryPreferences.max, `${SALES_ORDER_HEADER_CONSTRAINTS.deliveryPreferences.label} must be ${SALES_ORDER_HEADER_CONSTRAINTS.deliveryPreferences.max.toLocaleString('en-US')} characters or less.`)
        .optional()
        .nullable(),
    // The order's contact *name* is not an input -- it is derived from customerContactId by
    // resolve-customer-contact-update-fields.ts (apps/api), so the pair can never disagree.
    customerContactId: optionalUuidString('Invalid customer contact selection.')
        .optional()
        .nullable(),
});
//# sourceMappingURL=create-input.js.map